import { useMemo } from 'react';

import { getJobBoardClientNameFromLocalStorage } from 'helpers/jobBoardClientNameLocalStorage/getJobBoardClientNameFromLocalStorage';

export const useIsReasonableAdjustmentAvailable = () => {
  const currentClient = getJobBoardClientNameFromLocalStorage();

  return useMemo(() => {
    switch (currentClient) {
      case 'staging-morrisons':
      case 'morrisons':
      case 'staging-mands-joy':
      case 'mands-joy':
      case 'staging-moj':
      case 'moj':
        return false;
      default:
        return true;
    }
  }, [currentClient]);
};
